export default { sha: 'c45fa29fbc70d6bbc6d26eea33ab12623618345e', buildNumber: 'undefined' }
